import RestAPI from "../../../util/RestAPI";

type SetFieldOptions = {
  fieldName: "last_active_date";
};

// use groupList as type options for group
export async function setField(setFieldOptions: SetFieldOptions) {
  const { fieldName } = setFieldOptions;

  let value: string;

  switch (fieldName) {
    case "last_active_date":
      value = new Date().toISOString();
      break;
  }

  try {
    await RestAPI.put(`/mail/fields/${fieldName}/${value}`);
  } catch (err) {
    console.error(err);
  }
}
